import { useEffect, useState } from "react";

const useTimer = (initialTime: number, onReset?: () => void) => {
  const [timer, setTimer] = useState<number>(initialTime);
  const [resetCount, setResetCount] = useState(0);

  const formatSeconds = (totalSeconds: number) => {
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(
      2,
      "0"
    )}`;
  };

  const resetTimer = () => {
    setTimer(initialTime);
    setResetCount((prev) => prev + 1);
    if (onReset) onReset();
  };

  useEffect(() => {
    setTimer(initialTime);
  }, [initialTime]);

  useEffect(() => {
    const interval = setInterval(() => {
      setTimer((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [resetCount]);

  return { timer, resetTimer, formatSeconds };
};

export default useTimer;
